import React, { useState } from 'react';
import { Paper, FormControl, InputLabel, Select, MenuItem, Button, Box, CircularProgress } from '@mui/material';
import { useParams } from 'react-router-dom';
import { exportCTInstances } from '@services/dashboardService';
import { showErrorSnackbar, showSuccessSnacbar } from '@components/shared-layouts/Snackbar/helper';
import Colors from '@constants/Colors';

function ExportCTInstancesPage() {
  const { projectId } = useParams<{ projectId: string }>();
  const [format, setFormat] = useState<string>('export-all-instances');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!projectId) {
      showErrorSnackbar('Project ID is missing');
      return;
    }

    try {
      setIsSubmitting(true);
      const response = await exportCTInstances(projectId);
      showSuccessSnacbar(response?.data?.message || 'Export started successfully');
    } catch (error: any) {
      console.error('Error exporting CT instances:', error);
      const errorMessage = error?.error?.message || 'Failed to export CT instances';
      showErrorSnackbar(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Paper
      elevation={3}
      sx={{
        padding: '20px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '0px',
        backgroundColor: Colors.neutralwhite_50,
      }}
    >
      <h4 style={{ 
        marginBottom: '24px',
        color: Colors.neutralblack,
        fontWeight: 600 
      }}>
        Export CT Instances
      </h4>
      
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', maxWidth: '500px' }}>
        <FormControl sx={{ mb: 3, minWidth: 300 }}>
          <InputLabel id="format-select-label">Format</InputLabel>
          <Select
            labelId="format-select-label"
            id="format-select"
            value={format}
            label="Format"
            onChange={(e) => setFormat(e.target.value)}
            disabled={isSubmitting}
          >
            <MenuItem value="export-all-instances">Export All Instances</MenuItem>
          </Select>
        </FormControl>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={isSubmitting}
            sx={{
              backgroundColor: Colors.primary,
              '&:hover': {
                backgroundColor: Colors.primary_600,
              },
              minWidth: '120px',
            }}
          >
            {isSubmitting ? (
              <>
                <CircularProgress color="inherit" size={20} sx={{ mr: 1 }} />
                Exporting...
              </>
            ) : (
              'Submit'
            )}
          </Button>
        </Box>
      </form>
    </Paper>
  );
}

export default ExportCTInstancesPage;

